import type { ConversationSnapshot, Message } from 'talkjs/all';
import type {
  ConversationSummaryWithLoadingState,
  StoredConversationSummary,
  StoredConversationSummaryWithLoadingState,
} from './types';

export function summaryFromTalkJsMessage(
  message: Message,
): StoredConversationSummary {
  return {
    lastMessage: {
      text: message.body,
      createdAt: message.timestamp,
      senderName: message.sender?.name ?? null,
      senderAgencyName: message.sender?.custom?.['org_name'] ?? null,
    },
  };
}

export function summaryFromTalkJsConversationSnapshot(
  conversation: ConversationSnapshot,
): StoredConversationSummary {
  const lastMessage = conversation.lastMessage;
  return {
    lastMessage: lastMessage
      ? {
          text: lastMessage.plaintext,
          createdAt: lastMessage.createdAt,
          senderName: lastMessage.sender?.name ?? null,
          senderAgencyName: lastMessage.sender?.custom?.['org_name'] ?? null,
        }
      : null,
  };
}

export function summaryFromStoredSummary(
  stored: StoredConversationSummaryWithLoadingState,
  isUnread: boolean,
): ConversationSummaryWithLoadingState {
  if (stored.isLoading) {
    return { isLoading: true, summary: null };
  }
  if (stored.summary === null) {
    return { isLoading: false, summary: null };
  }
  return {
    isLoading: false,
    summary: {
      isUnread,
      lastMessage: stored.summary.lastMessage,
    },
  };
}
